// extracted by mini-css-extract-plugin
export default {"rewriteConfirm":"rewriteConfirm_AbezQ"};